<!-- Copyright 2026, Common Good Learning Tools LLC -->
<template><k-dialog v-model="dialog_open" fullscreen persistent scrollable><k-card>
<k-card-title class="k-rcram-title"">
	<!-- <img src="https://rosetta.commongoodlt.com/app/images/cglt-globe-with-stars.svg" -->
	<img class="k-rcram-logo" src="/images/cglt-globe-with-stars.svg">
	<b>Satchel Rosetta Align</b> <span class="ml-2">Competency <k-icon color="#000">fas fa-arrows-left-right</k-icon> Resource Alignment Matrix</span>
	<k-spacer/>
	<k-btn v-if="!cram_report_id" color="primary" @click="$emit('dialog_cancel')">Done</k-btn>
</k-card-title>
<k-card-text class="k-rcram-body">
	<div class="d-flex k-rcram-h1">
		<div class="k-rcram-h1"><b>Resource Set:</b> Life Sciences 5e (BJU Press)</div>
		<k-spacer/>
		<div class="k-rcram-h1"><b>Competency Framework:</b> <a href="https://rosetta.commongoodlt.com/f228b6ac-1313-11eb-80c4-0242c0a84003/b223b403-6caf-48f5-9b49-013b06aedacd/451" target="_blank">Virginia Science Standards</a></div>
			<!-- <span class="ml-4" style="font-size:18px"><b>Framework “branch”:</b> <a href="https://rosetta.commongoodlt.com/f228b6ac-1313-11eb-80c4-0242c0a84003/b223b403-6caf-48f5-9b49-013b06aedacd/451" target="_blank">Life Science</a></span> -->
	</div>
	<div class="k-rcram-grid-outer elevation-5" v-if="matrix">
		<k-data-table light dense
			:headers="headers"
			hide-default-header
			:items="table_rows"
			:items-per-page="-1"
			hide-default-footer
			xfooter-props="footer_options"
			height="calc(100vh - 124px)"
			class="k-rcram-table"
		>
			<!-- HEADER ROWS -->
			<template v-slot:header><thead>
				<tr class="k-rcram-table-header">
					<th class="k-rcram-table-comp-header-cell" style="border-bottom-color:transparent!important;"></th>

					<th class="text-center py-3"
						style="font-size:18px!important;"
						:colspan="n_resources" 
					><b>RESOURCES</b></th>
				</tr>

				<tr class="k-rcram-table-header">
					<th v-for="(header, i) in headers"
						:key="(i==0) ? 'cell0' : header.resource_id"
						:id="(i==0) ? '' : `th-${header.resource_id}`"
						:width="(i==0) ? '340' : '100'"
						:class="(i==0) ? 
						       'k-rcram-table-comp-header-cell text-center'
							   : (table_cell_class('', header.resource_id) + ' k-rcram-table-resource-header-cell text-center')
							   "
					>
						<div v-if="i==0" class="pb-2" style="font-size:18px!important;">
							<b>COMPETENCIES</b>
							<!-- button to return to default sort by competencies -->
							<k-btn x-small color="#333" outlined class="ml-2"
								v-show="sort_by!='comps'"
								@click="sort_by='comps'"
							><k-icon small color="#333" class="mr-2">fas fa-sort</k-icon>Default Sort</k-btn>
						</div>

						<!-- Resource header cells -->
						<div v-else class="k-rcram-resource-header-div">
							<div v-html="header.text"></div>
							<div class="k-rcram-resource-header-btns">

								<!-- button to sort by this resource -->
								<k-btn x-small color="#333" outlined
									@click="sort_by={dim:'resource', id:header.resource_id}"
								><k-icon small color="#333">fas fa-sort</k-icon></k-btn>

								<!-- button to show details for this resource -->
								<k-btn x-small color="#333" outlined class="ml-1"
									@click="display={dim:'resource', id:header.resource_id}"
								><k-icon small color="#333">fas fa-magnifying-glass-plus</k-icon></k-btn>

							</div>
						</div>
					</th>
				</tr>
			</thead></template>

			<!-- BODY ROWS -->
	 		<template v-slot:item="{ item }"><tr>
				<!-- Competency header cells -->
				<td class="k-rcram-table-comp-header-cell" width="340"
					:class="table_cell_class(item.comp_id, '')"
					:id="`th-${item.comp_id}`"
				>
					<div v-html="item.comp_text"></div>
					<div class="k-rcram-comp-header-btns">

						<!-- button to sort by this comp -->
						<k-btn x-small color="#333" outlined
							@click="sort_by={dim:'comp', id:item.comp_id}"
						><k-icon small color="#333">fas fa-fw fa-sort fa-rotate-90</k-icon></k-btn>

						<!-- button to show details for this comp -->
						<k-btn x-small color="#333" outlined class="mt-1"
							@click="display={dim:'comp', id:item.comp_id}"
						><k-icon small color="#333">fas fa-fw fa-magnifying-glass-plus</k-icon></k-btn>

					</div>
				</td>

				<!-- simscore cells for each resource-comp pair -->
				<td v-for="(cell) in item.cells"
					:key="cell.resource_id"
					class="k-rcram-table-simscore-cell"
					:class="`${table_cell_class(item.comp_id, cell.resource_id)} ${cell.cat.cell_class}`"
				>
					<k-icon>{{cell.cat.icon}}</k-icon>
				</td>
			</tr></template>

		</k-data-table>
	</div>
	
	<div v-if="key_showing" class="k-rcram-key">
		<div class="text-center mb-1">
			<k-btn small outlined color="primary"
				@click="key_showing = false"
			><k-icon small class="mr-2">fas fa-key</k-icon> Hide Key</k-btn>
		</div>

		<div v-for="(cat, i) in recommendation_categories" class="k-rcram-key-entry"
			:class="cat.cell_class"
		>
			<span style="display:inline-block; width:30px; text-align:center">
				<k-icon small>{{cat.icon}}</k-icon>
			</span>
			{{cat.label}}
		</div>
	</div>

	<div v-if="!key_showing" class="k-rcram-key-btn">
		<k-btn small color="primary"
			@click="key_showing = true"
		><k-icon small class="mr-2">fas fa-key</k-icon> Show Key</k-btn>
	</div>

</k-card-text>
</k-card></k-dialog></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		// req: { type: String, required: true },
		cram_params: { required: false, default() { return null } },
		cram_report_id: { type: String, required: false, default() { return '1001'} },
	},
	data() { return {
		dialog_open: true,

		// note that the matrix is indexed first by standard (comp_id), then by chapter (resource_id)
		matrix: null,
		rfr: null,
		cfr: null,

		footer_options: {
			itemsPerPageOptions: [100,-1],
		},

		sort_by: 'comps',
		display: 'matrix',
		table_row_update: true,
		key_showing: true,

		recommendation_categories: [
			{
				label: 'Highly Likely Direct Alignment',
				threshold: 80,
				cell_class: 'k-rcram-table-simscore-cell-4',
				icon: 'fas fa-fw fa-circle-star'
			},
			{
				label: 'Likely Direct Alignment',
				threshold: 50,
				cell_class: 'k-rcram-table-simscore-cell-4',
				icon: 'fas fa-fw fa-circle'
			},
			{
				label: 'Likely Partial Support',
				threshold: 35,
				cell_class: 'k-rcram-table-simscore-cell-3',
				icon: 'fas fa-fw fa-circle-half-stroke'
			},
			{
				label: 'Possible Contextual Relevance',
				threshold: 20,
				cell_class: 'k-rcram-table-simscore-cell-2',
				icon: 'far fa-fw fa-circle'
			},
			{
				label: 'Minimal/Surface Relevance',
				threshold: 10,
				cell_class: 'k-rcram-table-simscore-cell-1',
				icon: 'far fa-fw fa-circle'
			},
			{
				label: 'Not Relevant',
				threshold: 0,
				cell_class: 'k-rcram-table-simscore-cell-0',
				icon: 'fas fa-fw fa-minus'
			},
		]
	}},
	computed: {
		...mapState([]),
		...mapGetters([]),

		// TODO: look these up based on cram_report_id or cram_params
		resource_framework_id() { 
			return 'd51823e4-b8bd-4990-9e02-2c3ce7fafb3e'
		},
		resource_branch() { 
			return 'e3f26c6a-25c9-466f-a3bf-3753d765c3cf'
		},
		comp_framework_id() { 
			return 'f228b6ac-1313-11eb-80c4-0242c0a84003'
		},
		comp_branch() { 
			return 'b223b403-6caf-48f5-9b49-013b06aedacd'
		},

		resource_ids() {
			if (!this.matrix || !this.rfr) return []

			let arr = []
			for (let comp_id in this.matrix) {
				for (let resource_id in this.matrix[comp_id]) {
					arr.push(resource_id)
				}
				break
			}

			// if we're sorting by a competency, do so by sorting the resource_ids here
			if (this.sort_by?.dim == 'comp') {
				// console.warn('update resource_ids')
				this.table_row_update = false
				setTimeout(x=>this.table_row_update = true, 0)

				let comp_id = this.sort_by.id
				arr.sort((a,b)=>{
					return this.matrix[comp_id][b] - this.matrix[comp_id][a]
				})
			}

			return arr
		},
		n_resources() { return this.resource_ids.length },
		resource_cfitems() {
			if (!this.matrix || !this.rfr) return {}
			let o = {}
			for (let resource_id of this.resource_ids) {
				o[resource_id] = this.rfr.cfo.cfitems[resource_id]
			}
			return o
		},

		comp_ids() {
			if (!this.matrix || !this.cfr) return []

			let arr = []
			for (let comp_id in this.matrix) {
				arr.push(comp_id)
			}

			// if we're sorting by a resource, do so by sorting the comp_ids here
			if (this.sort_by?.dim == 'resource') {
				// console.warn('update comp_ids')
				this.table_row_update = false
				setTimeout(x=>this.table_row_update = true, 0)

				let resource_id = this.sort_by.id
				arr.sort((a,b)=>{
					return this.matrix[b][resource_id] - this.matrix[a][resource_id]
				})
			}

			return arr
		},
		n_comps() { return this.comp_ids.length },
		comp_cfitems() {
			if (!this.matrix || !this.cfr) return {}
			let o = {}
			for (let comp_id of this.comp_ids) {
				o[comp_id] = this.cfr.cfo.cfitems[comp_id]
			}
			return o
		},

		headers() {
			// headers (columns) are resources (e.g. chapters)
			let arr = []

			// first column is the competencies (e.g. standards)
			arr.push({
				text: 'COMPETENCY',
				align: 'left',
				// sortable: false,
				value: 'comp_text',
			})

			// one column per resource
			for (let resource_id of this.resource_ids) {
				let r = this.resource_cfitems[resource_id]
				arr.push({
					text: this.cfitem_title(r, 60),
					resource_id: resource_id,
					align: 'center',
					value: `simscore-${resource_id}`,
					cfi: r,
				})
			}
			return arr
		},

		table_rows() {
			if (!this.matrix || !this.cfr) return []
			if (!this.table_row_update) return []

			// console.warn('update table_rows: ' + this.table_row_update)
			let arr = []

			// one row per comp
			let i = 0
			for (let comp_id of this.comp_ids) {
				let c_cfi = this.comp_cfitems[comp_id]
				++i

				// first cell is the comp itself; get that info
				let o = {
					comp_id: comp_id,
					comp_sequence: i,
					comp_text: this.cfitem_title(c_cfi, 120),
					c_cfi: c_cfi,
					
					// this will hold the cells
					cells: []
				}

				for (let resource_id of this.resource_ids) {
					let simscore = this.matrix[comp_id][resource_id]
					let r_cfi = this.resource_cfitems[resource_id]
					o[`simscore-${resource_id}`] = simscore
					o.cells.push({
						r_cfi: r_cfi,
						resource_id: resource_id,
						resource_text: this.cfitem_title(r_cfi),
						simscore: simscore,
						cat: this.rco(simscore)
					})
					// arr.push({
					// 	simscore: this.matrix[comp_id][resource_id],
					// 	resource_text: this.cfitem_title(r_cfi),
					// 	cfi: r_cfi
					// })
				}

				arr.push(o)
			}

			// // sort rows
			// if (this.sort_by == 'comps') {
			// 	// show in the original order, so no sorting

			// // other possible values for sort_by will be objects with values `dim` and `id`
			// } else if (this.sort_by.dim == 'resource') {
			// 	let resource_id = this.sort_by.id
			// 	arr.sort((a,b)=>{
			// 		// console.log(`${resource_id} ${this.matrix[b.comp_id][resource_id]} - ${this.matrix[a.comp_id][resource_id]}`)
			// 		return this.matrix[b.comp_id][resource_id] - this.matrix[a.comp_id][resource_id]
			// 	})
			// }

			return arr
		},
	},
	watch: {
		sort_by() {
			U.loading_start()
			let container = '.k-rcram-grid-outer .v-data-table__wrapper'

			// default sort: go to the top-left
			if (this.sort_by == 'comps') {
				setTimeout(x=>{
					$(container)[0].scrollTop = 0
					$(container)[0].scrollLeft = 0
					U.loading_stop()
				}, 50)

			// if we're sorting by a resource or comp, scroll to it after a delay
			} else {
				let selector = `#th-${this.sort_by.id}`	// this works regardless of `dim` value
				
				// sort by comp (row): scroll to the left, then scroll vertically to the competency row
				if (this.sort_by.dim == 'comp') {
					setTimeout(x=>{
						$(container)[0].scrollLeft = 0
						// use goto to scroll horizontally to the comp's row
						this.$vuetify.goTo(selector, {
							container: container, 
							duration:300, 
							offset:60,
						})
						U.loading_stop()
					}, 50)

				// sort by resource (column): scroll to the top, then scroll horizontally to the resource column
				} else {
					setTimeout(x=>{
						$(container)[0].scrollTop = 0
						// offset must take account of the competency cell on the left
						U.scroll_horizontal_to(selector, container, 340)
						U.loading_stop()
					}, 50)
				}
			}
		},
	},
	created() {
		vapp.resource_matrix_view = this
		this.load_data()
	},
	mounted() {
	},
	methods: {
		async load_data() {
			U.loading_start()

			// get the matrix
			let payload = {
				filename: 'chapter-matrix-bju-va'
			}
			let result = await U.ajax_promise('get_last_alignment_matrix', payload)
			if (empty(result?.json)) {
				console.error('couldn’t fetch matrix')
				return
			}

			// remove comments
			let json = result.json.replace(/^(?:[ \t]*\/\/[^\n]*\n)+/, '')
			json = JSON.parse(json)

			// TEMP: arbitrarily reduce scores for chapter 1
			for (let comp_id in json) {
				for (let resource_id in json[comp_id]) {
					let x = json[comp_id][resource_id]
					x -= 30
					if (x < 0) x = 0
					json[comp_id][resource_id] = x
					break
				}
			}

			this.matrix = json

			// get the resource and comp framework_record
			this.rfr = await U.load_framework_and_cfo(this.resource_framework_id)
			this.cfr = await U.load_framework_and_cfo(this.comp_framework_id)

			U.loading_stop()
		},

		cfitem_title(cfi, length = 60) {
			let s = cfi.fullStatement
			if (!empty(cfi.humanCodingScheme)) s = `**${cfi.humanCodingScheme}** ${s}`
			return U.marked_latex(s)
			// return U.generate_cfassociation_node_uri_title(cfi, length, true)
		},

		rco(simscore) {
			let cat
			for (cat of this.recommendation_categories) {
				if (simscore >= cat.threshold) return cat
			}
			return cat
		},

		table_cell_class(comp_id, resource_id) {
			if (this.sort_by?.dim == 'resource') {
				if (resource_id == this.sort_by.id) {
					return 'k-rcram-sorted-resource-cell'
				}
				
			} else if (this.sort_by?.dim == 'comp') {
				if (comp_id == this.sort_by.id) {
					return 'k-rcram-sorted-comp-cell'
				}
			}
		},
	}
}
</script>

<style lang="scss">
.k-rcram-title {
	border-bottom:1px solid transparent;
	background-color:$v-blue-lighten-5;
	padding:0 24px 0 70px!important;
	height:60px;
}

.k-rcram-logo {
	position:fixed;
	left:-36px;
	top:-36px;
	height:100px;
}

.k-rcram-body {
	padding:12px!important;
	font-size:16px;
}

.k-rcram-h1 {
	font-size:20px;
	line-height:24px;
	margin:0 4px 6px 4px;
}
.k-rcram-h2 {
	font-size:18px;
	line-height:21px;
	margin-bottom:12px;
}

.k-rcram-grid-outer {
	overflow:scroll;
	border-radius:8px;
	border:1px solid #000;
}

.k-rcram-table {
	max-width:none!important;

	.v-data-table__wrapper {
		// this makes it so that we can always scroll the resource columns to right next to the competencies
		padding-right:calc(100vw - 372px);
	}

	table {
		// without this the table is squeezed to 100%
		width:max-content!important;
		table-layout: fixed;
		border-top:1px solid #ccc;
		border-right:1px solid #000!important;
	}
}

/* Make all header cells sticky at the top */
.k-rcram-table th {
	position: sticky;
	top: 0;
	z-index: 2;
	background-color: var(--v-background-base, #fff);
}

/* Pin the first column body cells to the left */
.k-rcram-table td:first-child {
	position: sticky;
	left: 0;
	z-index: 3;
	background-color: var(--v-background-base, #fff);
}

/* Pin top-left intersection cell (First Column Header) */
.k-rcram-table th:first-child {
	position: sticky;
	top: 0;
	left: 0;
	z-index: 4;
	background-color: var(--v-background-base, #fff);
}

.k-rcram-table-header {
	th {
		padding: 4px 6px !important;
		height: 12px !important;
		font-size: 12px !important;
		line-height:14px!important;
		vertical-align: bottom;
		font-weight: normal;
		cursor: pointer;
		color:#000!important;
		border-left:1px solid #ccc;
		vertical-align:top;
		// background-color:#ddd;

		// this makes rendering marked latex work better
		p { margin:0!important; }
	}
}

.k-rcram-table-comp-header-cell {
	// width:300px!important;
	font-size:12px!important;
	line-height:15px;
	// background-color:#ddd;
	padding:6px 40px 6px 6px!important;
	border-left:1px solid #ccc;
	border-right:1px solid #ccc;
	position:relative;
	border-right:1px solid #000!important;

	// this makes rendering marked latex work better
	p { margin:0!important; }

	.v-btn { opacity:0.3; }
}
.k-rcram-table-comp-header-cell:hover {
	.v-btn { opacity:1; }
}

th.k-rcram-table-comp-header-cell {
	vertical-align:bottom!important;
	border-bottom:1px solid #000!important;
}

.k-rcram-comp-header-btns {
	position:absolute;
	right:0px;
	top:0;
	display:flex;
	flex-direction:column;
	justify-content: center;
	align-items: center;
	padding-right:4px;
	height:100%;

	.v-btn {
		min-width:32px!important;
		padding:0!important;
	}
}

.k-rcram-table-resource-header-cell {
	// width:100px;
	font-size:12px!important;
	line-height:15px;
	border-left:1px solid #ccc;
	border-top:1px solid #ccc;
	border-bottom:1px solid #000!important;
	text-align:center;
	position:relative;
	.v-btn { opacity:0.3; }
}
.k-rcram-table-resource-header-cell:hover {
	.v-btn { opacity:1; }
}

.k-rcram-table-resource-header-cell.k-rcram-sorted-resource-cell {
	border-top:2px solid #000!important;
}

.k-rcram-resource-header-div {
	padding-bottom:26px!important;
}

.k-rcram-resource-header-btns {
	position:absolute;
	bottom:0;
	left:0;
	width:100%;
	display:flex;
	justify-content: center;
	padding-bottom:6px;
	.v-btn {
		min-width:32px!important;
		padding:0!important;
	}
}

.k-rcram-table-simscore-cell {
	// width:100px;
	font-size:12px!important;
	line-height:15px;
	border-left:1px solid #ccc;
	text-align:center;
}

// it's imported that the `-sorted-` selectors appear above the `-simscore-` selectors so that the background-colors cascade poperly
.k-rcram-sorted-resource-cell {
	border-left:2px solid #000!important;
	border-right:2px solid #000!important;
	font-weight:bold!important;
	background-color: #aaa!important;
	.v-btn { opacity:1; }
}
.k-rcram-sorted-comp-cell {
	border-top:2px solid #000!important;
	border-bottom:2px solid #000!important;
	font-weight:bold!important;
	background-color: #aaa!important;
	.v-btn { opacity:1; }
}

.k-rcram-table-simscore-cell-4 {   
	background-color:$v-green-lighten-3!important;
	.v-icon { color: $v-green-darken-4; }
}
.k-rcram-table-simscore-cell-3 {   
	background-color:$v-blue-lighten-3!important;
	.v-icon { color: $v-blue-darken-4; }
}
.k-rcram-table-simscore-cell-2 {   
	background-color:$v-amber-lighten-3!important;
	.v-icon { color: $v-amber-darken-3; }
}
.k-rcram-table-simscore-cell-1 {   
	background-color:$v-grey-lighten-3!important;
	.v-icon { color: $v-grey-darken-4; font-size:12px!important; }
}
.k-rcram-table-simscore-cell-0 {   
	background-color:#fff!important;
	.v-icon { color: #666; font-size:12px!important; }
}

.k-rcram-key {
	position:fixed;
	right:8px;
	bottom:8px;
	border:1px solid #000;
	border-radius:6px;
	background-color:#fff;
	padding:4px 0 4px 0;
	.k-rcram-table-simscore-cell-4, .k-rcram-table-simscore-cell-3, .k-rcram-table-simscore-cell-2 {   
		.v-icon { margin-top:-2px }
	}
	.k-rcram-table-simscore-cell-1, .k-rcram-table-simscore-cell-0 {   
		.v-icon { margin-top:-3px }
	}
}

.k-rcram-key-entry {
	padding:2px 8px 2px 2px;
}

.k-rcram-key-btn {
	position:fixed;
	right:8px;
	bottom:8px;
}

</style>